import React, { useMemo, useState } from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const documents = [
  {
    title: "Sertifikat o reakreditaciji",
    file: "21-2. Sertifikat o reakreditaciji.pdf",
  },
  {
    title: "Reakreditacija ustanove",
    file: "21-1. Reakreditacija ustanove.pdf",
  },
  {
    title: "Licenca za obavljanje naucno-istrazivacke djelatnosti",
    file: "20. Licenca za obavljanje naucno-istrazivacke djelatnosti.pdf",
  },
  {
    title: "Dopuna licence za osnovne i postdiplomske master studije",
    file: "19. Dopuna licence za osnovne i postdiplomske master studije.pdf",
  },
  {
    title:
      "Akreditacija - postdiplomske master akademske studije Poslovna ekonomija",
    file: "18. Akreditacija - postdiplomske master akademske studije Poslovna ekonomija.pdf",
  },
  {
    title:
      "Akreditacija - postdiplomske master akademske studije Ekonomija javnog sektora",
    file: "17. Akreditacija - postdiplomske master akademske studije Ekonomija javnog sektora.pdf",
  },
  {
    title:
      "Akreditacija - osnovne akademske studije Racunovodstvo, finansije i bankarstvo",
    file: "16. Akreditacija - osnovne akademske studije Racunovodstvo, finansije i bankarstvo.pdf",
  },
  {
    title: "Akreditacija - osnovne akademske studije Menadzment",
    file: "15. Akreditacija - osnovne akademske studije Menadzment.pdf",
  },
  {
    title: "PRAVO Osnovne i Postdiplomske LICENCA",
    file: "14. PRAVO Osnovne i Postdiplomske LICENCA.pdf",
  },
  {
    title: "PRAVO Postdiplomske master studije AKREDITACIJA",
    file: "13. PRAVO Postdiplomske master studije AKREDITACIJA.pdf",
  },
  {
    title: "PRAVO Osnovne studije AKREDITACIJA",
    file: "12. PRAVO Osnovne studije AKREDITACIJA.pdf",
  },
  {
    title: "Licenca za obavljanje naucno-istrazivacke djelatnosti",
    file: "11. Licenca za obavljanje naucno-istrazivacke djelatnosti.pdf",
  },
  {
    title: "Rjesenje o licenciranju Univerzitet ADRIATIK",
    file: "10. Rjesenje o licenciranju Univerzitet ADRIATIK.pdf",
  },
  {
    title: "Rjesenje o izmjeni broja studenata na specijalistickim studijama",
    file: "9. Rjesenje o izmjeni broja studenata na specijalistickim studijama.pdf",
  },
  {
    title: "Magistarske studije - dopuna licence",
    file: "8. Magistarske studije - dopuna licence.pdf",
  },
  {
    title: "Magistarske studija - akreditacija",
    file: "7. Magistarske studija - akreditacija.pdf",
  },
  {
    title: "Specijalisticke studije - dopuna licence",
    file: "6. Specijalisticke studije - dopuna licence.pdf",
  },
  {
    title: "Specijalisticke studije PROFITNI SEKTOR akreditacija",
    file: "5. Specijalisticke studije PROFITNI SEKTOR akreditacija.pdf",
  },
  {
    title: "Specijalisticke studije JAVNI SEKTOR akreditacija",
    file: "4. Specijalisticke studije JAVNI SEKTOR akreditacija.pdf",
  },
  {
    title: "Osnovne studije REAKREDITACIJA",
    file: "3. Osnovne studije REAKREDITACIJA.pdf",
  },
  { title: "Osnovne studije LICENCA", file: "2. Osnovne studije LICENCA.pdf" },
  {
    title: "Osnovne studije AKREDITACIJA",
    file: "1. Osnovne studije AKREDITACIJA.pdf",
  },
];

function Sidebar() {
  const [t] = useTranslation();

  return (
    <div className="col-md-4 pt-10">
      <aside className="sidebar-widget">
        <section
          id="custom_html-5"
          className="widget_text widget widget_custom_html"
        >
          <h2 className="widget-title">{t("sidebar.follow")}</h2>
          <div className="textwidget custom-html-widget">
            <div className="widget-social">
              <a
                href="https://www.facebook.com/fpebar.me"
                target="_blank"
                rel="noopener noreferrer"
                title="Facebook"
              >
                <i className="fab fa-facebook-f" />
              </a>
              <a
                href="https://www.instagram.com/fpepbar/"
                target="_blank"
                rel="noopener noreferrer"
                title="Instagram"
              >
                <i className="fab fa-instagram" />
              </a>
              <a
                href="https://www.youtube.com/@fpepbar"
                target="_blank"
                rel="noopener noreferrer"
                title="YouTube"
              >
                <i className="fab fa-youtube" />
              </a>
              <a
                href="https://www.tiktok.com/@fpepbar"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on Tiktok"
                title="Tiktok"
              >
                <i className="fab fa-tiktok" />
              </a>
              <a
                href="https://www.linkedin.com/school/fpepbar/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on LinkedIn"
                title="LinkedIn"
              >
                <i className="fab fa-linkedin-in" />
              </a>
            </div>
          </div>
        </section>

        <section id="categories-1" className="widget widget_categories">
          <h2 className="widget-title">{t("sidebar.useful")}</h2>
          <ul>
            <li className="cat-item cat-item-16">
              <Link to="/o-fpep">{t("about.fpep")}</Link>
            </li>
            <li className="cat-item cat-item-23">
              <Link to="/akreditacija-fpep">{t("admission.Akreditacija")}</Link>
            </li>
            <li className="cat-item cat-item-18">
              <Link to="/upis">{t("upis.title")}</Link>
            </li>
            <li className="cat-item cat-item-22">
              <Link to="/cijene-studija">{t("admission.Skolarina")}</Link>
            </li>
            <li className="cat-item cat-item-22">
              <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
            </li>
            <li className="cat-item cat-item-22">
              <Link to="/projekti">{t("saradnja.projekti")}</Link>
            </li>
            <li className="cat-item cat-item-22">
              <Link to="/dom-studenata">{t("studenti.dom")}</Link>
            </li>
            <li className="cat-item cat-item-22">
              <Link to="/galerija">{t("navbar.Gallery")}</Link>
            </li>
            <li className="cat-item cat-item-22">
              <Link to="/novosti">{t("navbar.News")}</Link>
            </li>
          </ul>
        </section>

        <section id="recent-posts-4" className="widget widget_recent_entries">
          <h2 className="widget-title">{t("sidebar.study")}</h2>
          <ul>
            <li>
              <span className="post-date">
                <strong>{t("programs.osnovne")}</strong> <br />
              </span>
              <Link to="/racunovodstvo-finansije-i-bankarstvo">
                {t("osnovne.rfb")}
                <br />
              </Link>
            </li>
            <li>
              <Link to="/menadzment">
                {t("osnovne.menadzment")}
                <br />
              </Link>
            </li>
            <li>
              <Link to="/pravo-osnovne">
                {t("osnovne.pravo")}
                <br />
              </Link>
            </li>

            <li>
              <span className="post-date">
                <strong>{t("programs.master")}</strong> <br />
              </span>
              <Link to="/poslovna-ekonomija">
                {t("master.poslovnaEkonomija")}
                <br />
              </Link>
            </li>
            <li>
              <Link to="/ekonomija-javnog-sektora">
                {t("master.ekonomijaJavnogSektora")}
                <br />
              </Link>
            </li>
            <li>
              <Link to="/pravo-master">
                {t("master.pravo")}
                <br />
              </Link>
            </li>

            <li>
              <span className="post-date">
                <strong>{t("programs.specijalisticke")}</strong> <br />
              </span>
              <Link to="/menadzment-javnog-sektora-specijalisticke">
                {t("specijalisticke.mjs")}
                <br />
              </Link>
            </li>
            <li>
              <Link to="/menadzment-profitnog-sektora-specijalisticke">
                {t("specijalisticke.mps")}
                <br />
              </Link>
            </li>
          </ul>
        </section>
      </aside>
    </div>
  );
}

function getStudentCategory(title) {
  const s = (title || "").toLowerCase();

  if (s.startsWith("pravo")) return "Pravo";
  if (s.includes("specijalist")) return "Specijalističke";
  if (
    s.includes("magistarske") ||
    s.includes("postdiplomske") ||
    s.includes("master")
  )
    return "Master";
  if (s.includes("naucno-istrazivacke")) return "Naučno-istraživačka";
  if (
    s.includes("reakreditacija") ||
    s.includes("sertifikat") ||
    s.includes("licenciranju univerzitet") ||
    s.includes("dopuna licence")
  )
    return "Ustanova";
  return "Osnovne";
}

function normalizeText(str) {
  return (str || "").toLowerCase().trim();
}

function AkreditacijaFPEP() {
  const { i18n } = useTranslation();
  const lang = i18n?.language?.startsWith("en") ? "en" : "me";

  const copy = {
    me: {
      title: "Akreditacija FPEP-a",
      lead: "Ovdje su dostupni PDF dokumenti akreditacija, licenci i pripadajućih rješenja. Stranica je koncipirana za buduće studente: dokumenti su grupisani po nivou studija i temama, uz brzu pretragu.",
      search: "Pretraži dokumente…",
      all: "Sve",
      open: "Otvori PDF",
      fileLabel: "Fajl",
      categories: {
        Osnovne: "Osnovne",
        Specijalističke: "Specijalističke",
        Master: "Master",
        Pravo: "Pravo",
        Ustanova: "Ustanova",
        "Naučno-istraživačka": "Naučno-istraživačka",
      },
      note: "Savjet: koristi filtere (npr. Osnovne / Master) da brže nađeš ono što ti treba.",
    },
    en: {
      title: "FPEP Accreditation",
      lead: "Here you can access PDF documents related to accreditations, licences and related decisions. The page is student-focused: documents are grouped by study level/topics with quick search.",
      search: "Search documents…",
      all: "All",
      open: "Open PDF",
      fileLabel: "File",
      categories: {
        Osnovne: "Undergraduate",
        Specijalističke: "Specialist",
        Master: "Master",
        Pravo: "Law",
        Ustanova: "Institution",
        "Naučno-istraživačka": "Research",
      },
      note: "Tip: use filters (e.g., Undergraduate / Master) to find documents faster.",
    },
  };

  const [query, setQuery] = useState("");
  const [activeCat, setActiveCat] = useState("ALL");

  const docs = useMemo(() => {
    return documents.map((d) => ({
      ...d,
      cat: getStudentCategory(d.title),
    }));
  }, []);

  const categories = useMemo(() => {
    const set = new Set(docs.map((d) => d.cat));
    return ["ALL", ...Array.from(set)];
  }, [docs]);

  const filtered = useMemo(() => {
    const q = normalizeText(query);
    return docs
      .filter((d) => {
        const matchesCat = activeCat === "ALL" || d.cat === activeCat;
        const matchesQuery =
          !q ||
          normalizeText(d.title).includes(q) ||
          normalizeText(d.file).includes(q);
        return matchesCat && matchesQuery;
      })
      .sort((a, b) => a.title.localeCompare(b.title));
  }, [docs, query, activeCat]);

  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Akreditacija FPEP-a" />

      <div className="docs-page docs-page--students">
        <div className="container mt-4 pt-60 pb-60">
          <div className="row">
            {/* MAIN */}
            <div className="col-md-8">
              <div className="docs-hero-card">
                <h1 className="docs-title">{copy[lang].title}</h1>
                <p className="docs-lead">{copy[lang].lead}</p>

                <div className="docs-toolbar">
                  <div className="docs-search">
                    <i className="fas fa-search" aria-hidden="true" />
                    <input
                      type="search"
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                      placeholder={copy[lang].search}
                      aria-label={copy[lang].search}
                    />
                  </div>
                </div>

                <div
                  className="docs-chips"
                  role="tablist"
                  aria-label="Filter kategorija"
                >
                  {categories.map((c) => {
                    const label =
                      c === "ALL"
                        ? copy[lang].all
                        : copy[lang].categories[c] || c;
                    const active = activeCat === c;
                    return (
                      <button
                        key={c}
                        type="button"
                        className={`docs-chip ${active ? "is-active" : ""}`}
                        onClick={() => setActiveCat(c)}
                        role="tab"
                        aria-selected={active}
                      >
                        {label}
                      </button>
                    );
                  })}
                </div>

                <div className="docs-muted">
                  <i className="fas fa-lightbulb" aria-hidden="true" />{" "}
                  {copy[lang].note}
                </div>
              </div>

              <div className="docs-grid">
                {filtered.map((doc) => (
                  <article className="doc-card" key={doc.file}>
                    <div className="doc-card-head">
                      <div className="doc-icon" aria-hidden="true">
                        <i className="fas fa-file-pdf" />
                      </div>

                      <div className="doc-head-text">
                        <div className="doc-tag">
                          {copy[lang].categories[doc.cat] || doc.cat}
                        </div>
                        <h3 className="doc-title">{doc.title}</h3>
                        <div className="doc-file">
                          <span className="doc-file-label">
                            {copy[lang].fileLabel}:
                          </span>{" "}
                          <code>{doc.file}</code>
                        </div>
                      </div>
                    </div>

                    <div className="doc-actions">
                      <a
                        className="doc-open"
                        href={`/Prilozi/${doc.file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${copy[lang].open}: ${doc.title}`}
                      >
                        {copy[lang].open}{" "}
                        <i className="fas fa-arrow-right" aria-hidden="true" />
                      </a>
                    </div>
                  </article>
                ))}

                {filtered.length === 0 && (
                  <div className="docs-empty-card">
                    Nema rezultata za zadatu pretragu.
                  </div>
                )}
              </div>
            </div>

            <Sidebar />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default AkreditacijaFPEP;
